import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Download, X } from 'lucide-react';

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Only show if not dismissed recently
      const dismissed = localStorage.getItem('pwa-dismissed');
      if (!dismissed || Date.now() - parseInt(dismissed) > 86400000) {
        setShow(true);
      }
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setShow(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShow(false);
    localStorage.setItem('pwa-dismissed', Date.now().toString());
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 sm:left-auto sm:right-4 sm:w-80 animate-slide-up" data-testid="pwa-install-prompt">
      <div className="bg-slate-900 text-white p-4 rounded-2xl shadow-2xl border border-slate-700">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0">
            <Download className="w-5 h-5" />
          </div>
          <div className="flex-1">
            <p className="font-bold text-sm">Installa HostFix</p>
            <p className="text-xs text-slate-400 mt-0.5">Accedi rapidamente dalla home del dispositivo</p>
          </div>
          <button onClick={handleDismiss} className="text-slate-500 hover:text-slate-300">
            <X className="w-4 h-4" />
          </button>
        </div>
        <Button 
          onClick={handleInstall} 
          className="w-full mt-3 bg-blue-600 hover:bg-blue-700 h-10 text-sm font-bold"
          data-testid="pwa-install-button"
        >
          <Download className="w-4 h-4 mr-2" />
          Installa App
        </Button>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
